/**
 * 时间戳
 * @param {*} timestamp  时间戳
 */

var api = require('../api/api.js')
const timestampToTime = (timestamp) => {
	let date = new Date(timestamp) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
	let Y = date.getFullYear() + '-'
	let M =
		(date.getMonth() + 1 < 10 ?
			'0' + (date.getMonth() + 1) :
			date.getMonth() + 1) + '-'
	let D =
		(date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
	let h =
		(date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
	let m =
		(date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
		':'
	let s =
		date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
	return Y + M + D + h + m + s
};
/**
 * 存储localStorage
 */
const setStore = (name, content) => {
	if (!name) return;
	if (typeof content !== 'string') {
		content = JSON.stringify(content);
	}
	window.localStorage.setItem(name, content);
}

/**
 * 获取localStorage
 */
const getStore = name => {
	if (!name) return;
	return window.localStorage.getItem(name);
}

/**
 * 删除localStorage
 */
const removeStore = name => {
	if (!name) return;
	window.localStorage.removeItem(name);
}

/**
 * 设置cookie
 **/
function setCookie(name, value, day) {
	let date = new Date();
	date.setDate(date.getDate() + day);
	document.cookie = name + '=' + value + ';expires=' + date;
};

/**
 * 获取cookie
 **/
function getCookie(name) {
	let reg = RegExp(name + '=([^;]+)');
	let arr = document.cookie.match(reg);
	if (arr) {
		return arr[1];
	} else {
		return '';
	}
};

/**
 * 删除cookie
 **/
function delCookie(name) {
	setCookie(name, null, -1);
};


/**
 * 封装request
 */
let requestCount = 0;

function request(url, data = {}, method = "GET") {
	requestCount++;
	uni.showLoading({
		title: '加载中',
		mask: true
	})
	var shopData = uni.getStorageSync('token')
	if (shopData) {
		//判定token是否已失效
		var now_Time = Date.parse(new Date())
		//判断token是否快失效
		if ((shopData.expire - 300) * 1000 < now_Time) {
			new Promise(function(resolve, reject) {
				uni.request({
					url: api.RefreshToken,
					method: "GET",
					header: {
						'Content-Type': 'application/json',
						//缓存的token值，用于标识用户，带在heard里
						'Authorization': shopData.token
					},
					success: function(res) {
						uni.setStorageSync('data', res.data.data)
					},
					fail: function(res) {
						uni.navigateTo({
							url: '/pages/auth/login/login',
						})
						reject(res)
					}
				})
			})
		}
	}
	return new Promise(function(resolve, reject) {
		uni.request({
			url: url,
			data: data,
			method: method,
			header: {
				'Content-Type': 'application/json',
				//缓存的token值，用于标识用户，带在heard里
				'Authorization': shopData.token
			},
			success: function(res) {
				switch (res.statusCode) {
					case 200:
						resolve(res)
						break
					case 403:
						uni.showToast({
							icon: 'none',
							title: "登录已过期",
							duration: 3000
						})
						//需要登录后才可以操作
						app.globalData.islogin = false
						uni.navigateTo({
							url: '/pages/auth/login/login'
						})
						reject(res)
						break
					default:
						uni.showToast({
							icon: 'none',
							title: "服务器内部错误",
							duration: 3000
						})
						break
				}
			},
			fail: function(err) {
				reject(err)
			},
			complete: () => {
				requestCount--
				if (requestCount === 0) {
					uni.hideLoading();
				}
			}
		})
	});
}


const grade = [{
		text: '小班',
		value: 0
	},
	{
		text: '中班',
		value: 1
	},
	{
		text: '大班',
		value: 2
	},
	{
		text: '学前班',
		value: 3
	},
	{
		text: '一年级',
		value: 4
	},
	{
		text: '二年级',
		value: 5
	},
	{
		text: '三年级',
		value: 6
	},
	{
		text: '四年级',
		value: 7
	},
	{
		text: '五年级',
		value: 8
	},
	{
		text: '六年级',
		value: 9
	},
	{
		text: '初一',
		value: 10
	},
	{
		text: '初二',
		value: 11
	},
	{
		text: '初三',
		value: 12
	},
	{
		text: '高一',
		value: 13
	},
	{
		text: '高二',
		value: 14
	},
	{
		text: '高三',
		value: 15
	},
	{
		text: '大一',
		value: 16
	},
	{
		text: '大二',
		value: 17
	},
	{
		text: '大三',
		value: 18
	},
	{
		text: '大三',
		value: 19
	},
	{
		text: '大四',
		value: 20
	},
	{
		text: '其他',
		value: 99
	}
]
const group = [
	[{
			text: '小学低年级',
			value: 0
		},
		{
			text: '小学高年级',
			value: 1
		},
		{
			text: '初中',
			value: 2
		},
		{
			text: '高中',
			value: 3
		}
	],
	[{
			text: '一年级',
			value: 0
		},
		{
			text: '二年级',
			value: 1
		},
		{
			text: '三年级',
			value: 2
		},
		{
			text: '四年级',
			value: 3
		},
		{
			text: '五年级',
			value: 4
		},
		{
			text: '六年级',
			value: 5
		}
	],
	[{
			text: '初一',
			value: 0
		},
		{
			text: '初二',
			value: 1
		},
		{
			text: '初三',
			value: 2
		}
	],
	[{
			text: '高一',
			value: 0
		},
		{
			text: '高二',
			value: 1
		},
		{
			text: '高三',
			value: 2
		}
	],
	[{
			text: 'Scratch',
			value: 0
		},
		{
			text: 'Python',
			value: 1
		},
		{
			text: 'C/C++',
			value: 2
		}
	],
	[{
			text: '初级',
			value: 0
		},
		{
			text: '中级',
			value: 1
		},
		{
			text: '高级',
			value: 2
		}
	]
]
const Skill = [{
			"text": "C++",
			"value": 0,
			"desc": "信息学奥赛 / 算法竞赛"
		},
		{
			"text": "Python",
			"value": 1,
			"desc": "人工智能 / 数据分析 / 趣味编程"
		},
		{
			"text": "图形化编程",
			"value": 2,
			"desc": "Scratch / Mind+"
		},
		{
			"text": "Arduino",
			"value": 3,
			"desc": "电子原型 / 传感器应用"
		},
		{
			"text": "网络安全入门",
			"value": 4,
			"desc": "密码学基础 / CTF初级 / 安全防护"
		},
		{
			"text": "人工智能",
			"value": 5,
			"desc": "机器学习 / 计算机视觉"
		},
		{
			"text": "机器人",
			"value": 6,
			"desc": "VEX / Makeblock / 竞赛（不含乐高）"
		},
		{
			"text": "JavaScript",
			"value": 7,
			"desc": "网页交互 / 全栈入门"
		},
		{
			"text": "HTML/CSS",
			"value": 8,
			"desc": "前端开发 / 响应式设计"
		},
		{
			"text": "无人机",
			"value": 9,
			"desc": "飞控编程 / 航拍竞技"
		},
		{
			"text": "创客",
			"value": 10,
			"desc": "创客教育 / 3D建模设计打印 / 激光切割"
		},
		{
			"text": "Go语言",
			"value": 11,
			"desc": "高并发 / 云原生"
		},
		{
			"text": "乐高",
			"value": 12,
			"desc": "LEGO Spike / 机器人搭建"
		},
		{
			"text": "Java",
			"value": 13,
			"desc": "AP CS / 信息学竞赛备选 / 企业级应用"
		},
		{
			"text": "micro:bit",
			"value": 14,
			"desc": "袖珍编程电脑 / 传感器入门"
		},
		{
			"text": "树莓派",
			"value": 15,
			"desc": "Linux系统 / Python硬件 / 物联网"
		},
		{
			"text": "移动应用开发",
			"value": 16,
			"desc": "App Inventor / Thunkable / 跨平台"
		},
		{
			"text": "电子电路基础",
			"value": 17,
			"desc": "面包板 / 元器件 / 模拟电路"
		},
		{
			"text": "游戏开发",
			"value": 18,
			"desc": "Unity / Roblox / 游戏设计逻辑"
		},
		{
			"text": "数据库/SQL",
			"value": 19,
			"desc": "数据存储 / 查询语句 / 与程序联动"
		},
		{
			"text": "其他",
			"value": 20,
			"desc": "其他内容"
		},
	],
	Poslist = [{
		text: '班主任',
		value: 0
	}, {
		text: '任课老师',
		value: 1
	}, {
		text: '教务老师',
		value: 2
	}, {
		text: '教学主管',
		value: 3
	}, {
		text: '竞赛教练',
		value: 4
	}, {
		text: '副校长',
		value: 5
	}, {
		text: '校长',
		value: 6
	}],
	posttab = [{
			text: '不设置标签',
			value: 0
		}, {
			text: '招聘',
			value: 1,
			c: "#2C3E50"
		},
		{
			text: '求职',
			value: 2,
			c: "#16A085"
		},
		{
			text: '求助',
			value: 3,
			c: "#E67E22"
		},
		{
			text: '经验分享',
			value: 4,
			c: "#27AE60"
		},
		{
			text: '组队/合作',
			value: 5,
			c: "#8E44AD"
		},
		{
			text: '活动/讲座',
			value: 6,
			c: "#F39C12"
		},
		{
			text: '资源分享',
			value: 7,
			c: "#1ABC9C"
		},
		{
			text: '二手/交易',
			value: 8,
			c: "#7F8C8D"
		},
		{
			text: '闲聊',
			value: 9,
			c: "#E84393"
		}, {
			text: '名师工作室',
			value: 10,
			c: "#3F51B5"
		}, {
			text: '官方公告',
			value: 11,
			c: "#D4AC0D"
		}, {
			text: '店铺',
			value: 12,
			c: "#795548"
		}
	],
	gradetype = {
		1: '幼儿园',
		2: '小学',
		3: '初中',
		4: '高中',
		5: '中职',
		6: '高职',
		7: '高校',
		49: '其他',
		98: '组织',
		99: '机构'
	},
	schooltype = {
		1: '公办学校（含幼儿园、中小学）',
		2: '小民办学校（含幼儿园、中小学）',
		3: '民办培训机构（含培训公司）',
		4: '公办培训机构（少年宫、科技馆等）',
		5: '国际学校',
		99: '其他'
	}
export {
	request,
	timestampToTime,
	setStore,
	getStore,
	removeStore,
	setCookie,
	getCookie,
	delCookie,
	Poslist,
	Skill
}


// WEBPACK FOOTER //
// ./src/utils/util.js